import home from './home.json';
import footer from './footer.json';
import preparation from './preparation.json';
import login from './login.json';
import forgotPassword from './forgotPassword.json';
import signup from './signup.json';
import detailApartment from './detailApartment.json';
import detailProject from './detailProject.json';
import serviceApartment from './serviceApartment.json';
import searchResult from './searchResult.json';
import offers from './offers.json';
import featuredProjects from './featuredProjects.json';
import servicedOffice from './servicedOffice.json';
import noResultFound from './noResultFound.json';
import aboutUs from './aboutUs.json';
import blogs from './blogs.json';
import title from './title.json';
import forOwners from './forOwners.json';
import helps from './helps.json';
import usefulPage from './usefulPage.json';
import validate from './validate.json';
import payment from './payment.json';
import location from './location.json';
import manageAccount from './manageAccount.json';

const en = {
  ...home,
  ...footer,
  ...preparation,
  ...login,
  ...forgotPassword,
  ...signup,
  ...detailApartment,
  ...detailProject,
  ...serviceApartment,
  ...searchResult,
  ...offers,
  ...featuredProjects,
  ...servicedOffice,
  ...noResultFound,
  ...aboutUs,
  ...blogs,
  ...title,
  ...forOwners,
  ...helps,
  ...usefulPage,
  ...validate,
  ...payment,
  ...location,
  ...manageAccount,
};

export { en };
